(function () {
    "use strict";

    angular.module("app").component("habilAttachments", {
        templateUrl: "@/attachments/attachments.html",
        bindings: { attachments: "=" },
        controller: AttachmentsController
    });

    AttachmentsController.$inject = ["$rootScope"];
    function AttachmentsController($rootScope) {
        const vm = this;

        vm.AttachmentTypes = $rootScope.codeAttachmentTypes;
    }
})();